import React from 'react';

import {
  Card,
  Row,
  Col,
  Avatar,
  Progress,
  Table,
  Typography,
  Space,
  Divider,
} from 'antd';

import {
  CalendarOutlined,
  TeamOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

import { useLocation } from 'react-router-dom';

const { Title, Text } = Typography;

const TrainingsOverView = () => {
  const location = useLocation();

  const overviewData =
    location?.state?.overviewData || {};

  const trainingDetails =
    overviewData?.training_details || {};

  const trainers =
    overviewData?.trainers || [];

  const trainees =
    overviewData?.trainees || [];

  // ================= TABLE COLUMNS =================

  const columns = [
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',

      render: (text) => (
        <Text strong>{text}</Text>
      ),
    },

    {
      title: 'DEPARTMENT',
      dataIndex: 'department',
      key: 'department',
    },

    {
      title: 'EMAIL',
      dataIndex: 'email',
      key: 'email',
    },

    {
      title: 'ATTENDANCE',
      dataIndex: 'attendance_percentage',
      key: 'attendance_percentage',

      render: (val) => (
        <Progress
          percent={Number(
            String(val).replace('%', '')
          )}
          size="small"
          strokeColor="#52c41a"
        />
      ),
    },
  ];

  return (
    <div
      style={{
    
        minHeight: '100vh',
      }}
    >
      {/* ================= HEADER CARD ================= */}

     <Card
  bodyStyle={{
    padding: '18px 28px',
  }}
  style={{
    marginBottom: 20,
    borderRadius: 6,
  }}
>
  <Row
    align="middle"
    justify="space-between"
    gutter={24}
  >
    {/* DURATION */}

    <Col>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div
          style={{
            background: '#e6f7ff',
            width: 40,
            height: 40,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CalendarOutlined
            style={{
              fontSize: 20,
              color: '#1890ff',
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div>
            <Text
              type="secondary"
              style={{
                fontSize: 13,
              }}
            >
              Duration
            </Text>

            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                lineHeight: '22px',
              }}
            >
              {trainingDetails?.duration}
            </div>
          </div>

          <Divider
            type="vertical"
            style={{
              height: 38,
              margin: '0 18px',
              borderInlineStart:
                '2px solid #1d39c4',
            }}
          />

          <div>
            <Text
              type="secondary"
              style={{
                fontSize: 13,
              }}
            >
              Year
            </Text>

            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                lineHeight: '22px',
              }}
            >
              {trainingDetails?.year}
            </div>
          </div>
        </div>
      </div>
    </Col>

    {/* TRAINERS */}

    <Col>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div
          style={{
            background: '#f9f0ff',
            width: 40,
            height: 40,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <TeamOutlined
            style={{
              fontSize: 20,
              color: '#722ed1',
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div>
            <Text
              type="secondary"
              style={{
                fontSize: 13,
              }}
            >
              Trainers
            </Text>

            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                lineHeight: '22px',
              }}
            >
              {
                trainingDetails?.trainers_count
              }
            </div>
          </div>

          <Divider
            type="vertical"
            style={{
              height: 38,
              margin: '0 18px',
              borderInlineStart:
                '2px solid #1d39c4',
            }}
          />

          <div>
            <Text
              type="secondary"
              style={{
                fontSize: 13,
              }}
            >
              Trainees
            </Text>

            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                lineHeight: '22px',
              }}
            >
              {
                trainingDetails?.trainees_count
              }{' '}
              enrolled
            </div>
          </div>
        </div>
      </div>
    </Col>

    {/* ATTENDANCE */}

    <Col>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div
          style={{
            background: '#f6ffed',
            width: 40,
            height: 40,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckCircleOutlined
            style={{
              fontSize: 20,
              color: '#52c41a',
            }}
          />
        </div>

        <div>
          <Text
            type="secondary"
            style={{
              fontSize: 13,
            }}
          >
            Avg Attendance (Overall progress)
          </Text>

          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: '22px',
            }}
          >
            {
              trainingDetails?.attendance_percentage
            }
          </div>
        </div>
      </div>
    </Col>
  </Row>
</Card>

      {/* ================= MAIN CONTENT ================= */}

      <Row gutter={24}>
        {/* TRAINERS */}

        <Col span={7}>
          <Title
            level={4}
            style={{
              marginBottom: 16,
            }}
          >
            Trainers
          </Title>

          {trainers.map((trainer) => (
            <Card
              key={trainer.id}
              style={{
                marginBottom: 16,
                borderRadius: 12,
               
              }}
              bodyStyle={{
                padding: 16,
              }}
            >
              <Space
                align="start"
                size="middle"
              >
                <Avatar
                  size={48}
                  style={{
                    backgroundColor:
                      '#1890ff',
                    fontWeight: 'bold',
                  }}
                >
                  {trainer?.name
                    ?.charAt(0)
                    ?.toUpperCase()}
                </Avatar>

                <div>
                  <Text
                    strong
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trainer.name}
                  </Text>

                  <br />

                  <Text
                    type="secondary"
                    style={{
                      fontSize: 13,
                    }}
                  >
                    {trainer.designation}
                  </Text>

                  <br />

                  <Text
                    type="secondary"
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {trainer.department}
                  </Text>

                  <br />

                  <Text
                    style={{
                      color: '#1890ff',
                      fontSize: 12,
                    }}
                  >
                    {trainer.email}
                  </Text>
                </div>
              </Space>
            </Card>
          ))}
        </Col>

        {/* TRAINEES */}

        <Col span={17}>
          <div
            style={{
              display: 'flex',
              justifyContent:
                'space-between',
              alignItems: 'flex-end',
              marginBottom: 8,
            }}
          >
            <Title
              level={4}
              style={{
                margin: 0,
              }}
            >
              Trainees
            </Title>

            <Text>
              Avg Attendance:{' '}
              <Text
                strong
                style={{
                  color: '#1890ff',
                }}
              >
                {
                  trainingDetails?.attendance_percentage
                }
              </Text>
            </Text>
          </div>

          <Card
            style={{
              borderRadius: 8,
            }}
          >
            {/* OVERALL PROGRESS */}

            <div
              style={{
                marginBottom: 24,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent:
                    'space-between',
                  marginBottom: 8,
                }}
              >
                <Text type="secondary">
                  Overall Progress
                </Text>

                <Text strong>
                  {
                    trainingDetails?.attendance_percentage
                  }
                </Text>
              </div>

              <Progress
                percent={Number(
                  String(
                    trainingDetails?.attendance_percentage ||
                      '0%'
                  ).replace('%', '')
                )}
                strokeColor="#1890ff"
                strokeWidth={12}
                showInfo={false}
              />
            </div>

            {/* TABLE */}

            <Table
              rowKey="id"
              dataSource={trainees}
              columns={columns}
              pagination={false}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TrainingsOverView;